import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudRain } from '@fortawesome/free-solid-svg-icons';

import { FormattedValue } from './FormattedValue';

interface RainStatsProps {
    rain: number;
    isLoaded: boolean;
}

const RainStats: React.FC<RainStatsProps> = ({ rain, isLoaded }) => {

    return <div className="column is-one-third metric rain-container">
                <div className="is-flex is-flex-direction-column">
                    <FontAwesomeIcon color='gray' size='2x' icon={faCloudRain} />
                    <FormattedValue isLoaded={isLoaded} value={rain} unit='mm'></FormattedValue>
                </div>
            </div>
}

export default RainStats;
